import React from 'react'
import Layout from '../components/layout'
import ClosedImg from '../images/closed-for-the-winter.png'
import ClosedJpg from '../images/closed-for-the-winter-season.jpg'
import CalendarImg from '../images/calendar-year-2019-2020.png'
import CalendarPdf from '../files/calendar-year-2019-2020.pdf'
import SteampunkImg from '../images/steampunk.png'
import TwistedImg from '../images/twister-christmas.jpg'
import AparimaPosterImg from '../images/poster-aparima.jpg'
import PoetryImg from '../images/poetry-night.png'
import EnrichImg from '../images/enrich-your-life-with-colours.png'
import SteampunkPdf from '../files/steampunk_registration_form.pdf'
import EntryTwistedPdf from '../files/entry-form-twisted-christmas.pdf'
import WhanauImg from '../images/whanau.png'
import TaiaoImg from '../images/taiao.png'
import TaiaoPdf from '../files/taiaoentryform.pdf'
import Link from 'gatsby-link'

const EventsPage = ({data}) => (
  <Layout>
    <section className="mw7 center">
      <h1 className="ph3 ph0-l bb bw2 pb3">Upcoming Events</h1>
      {/* {data.allWordpressPost.edges.map(({ node }) => (
      <article className="bb b--black-10">
        <div className="db pv4 ph3 ph0-l no-underline black">
          <div className="flex flex-column flex-row-ns">
            <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
            <img src={node.featured_media.localFile} className="db" alt="{}" />
            <p></p>
            </div>
            <div className="w-100 w-60-ns pl3-ns">
              <h2 className="mt0">{node.title}</h2>
              <p className="measure blogpost" dangerouslySetInnerHTML={{ __html: node.content }}></p>
            </div>
          </div>
        </div>
      </article>
    ))} */}
    <article className="bb b--black-10">
      <span className="db pv4 ph3 ph0-l no-underline black">
        <div className="flex flex-column flex-row-ns">
          <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
            <img src={TaiaoImg} className="db" alt="Call for Entry - Taiao Art Exhibition" />
          </div>
          <div className="w-100 w-60-ns pl3-ns">
            <h2 className="mt0">Call for Entry - Taiao Art Exhibition</h2>
            <p className="measure">
              <a className="turquoise fw6" href={TaiaoPdf}>Download the Entry Form</a>
            </p>  
          </div>
        </div>
      </span>
    </article>
    <article className="bb b--black-10">
      <span className="db pv4 ph3 ph0-l no-underline black">
        <div className="flex flex-column flex-row-ns">
          <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
            <img src={WhanauImg} className="db" alt="Enrich Your Life with Colours Art Exhibition" />
          </div>
          <div className="w-100 w-60-ns pl3-ns">
            <h2 className="mt0">Whanau Art Exhibition</h2>
            <p className="measure">
              <strong className="turquoise">14th March - April 5th 2020 </strong>
            </p>  
          </div>
        </div>
      </span>
    </article>
      <article className="bb b--black-10">
        <span className="db pv4 ph3 ph0-l no-underline black">
          <div className="flex flex-column flex-row-ns">
            <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
              <img src={EnrichImg} className="db" alt="Enrich Your Life with Colours Art Exhibition" />
            </div>
            <div className="w-100 w-60-ns pl3-ns">
              <h2 className="mt0">Enrich Your Life with Colours Art Exhibition</h2>
              <p className="measure">
              "Colours, special shapes and patterns are my main obsessions, I believe that colours have an influence over the quality of our lives.  Light, strong and vivid colours give me a sense of calm, hope, a good mood and happiness - while dark, greyish colours make me feel depressed or put me in a sad mood". Marta works with many different mediums: wool, glass, acrylic paint, resin and mosaic.</p>
              <p className="measure">
              Marta loves the Riverton Artist Community having become a member of the Riverton Arts Committee in 2018 and feels very proud to be a member of it. "I've had a chance to meet lots of very talented artists, and very curious people who come back time and time again to visit these exhibitions and I am very excited to be showing my work this January".
              </p>
              <p className="measure">
              Enrich Your Life With Colours Art Exhibition is on at the Riverton Community Arts Centre from <strong className="turquoise">January 11th till February 9th 2020</strong>.  The centre is open <strong className="turquoise">Wednesday till Sunday</strong> each week from <strong className="turquoise">11am till 4pm</strong> each day.  Mart will be at the gallery to meet visitors and talk about her art.
              </p>
             
            </div>
          </div>
        </span>
      </article>
      <article className="bb b--black-10">
        <span className="db pv4 ph3 ph0-l no-underline black">
          <div className="flex flex-column flex-row-ns">
            <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
              <img src={PoetryImg} className="db" alt="Poetry Night" />
            </div>
            <div className="w-100 w-60-ns pl3-ns">
              <h2 className="mt0">Poetry Night</h2>
              <p className="measure">
                 Wednesday <strong className="turquoise">November 6th at 7pm</strong><br/>
                 Bring a gold coin donation
              </p>
            </div>
          </div>
        </span>
      </article>
      <article className="bb b--black-10">
        <span className="db pv4 ph3 ph0-l no-underline black">
          <div className="flex flex-column flex-row-ns">
            <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
              <img src={TwistedImg} className="db" alt="A Twisted Christmas!" />
            </div>
            <div className="w-100 w-60-ns pl3-ns">
              <h2 className="mt0">A Twisted Christmas!</h2>
              <p className="measure">
                <strong className="turquoise">December 6th - January 5th 2019/2020</strong><br />
                 Think outside the box for this one fellow artists! Santa in drag, the Christmas party from hell, exploding presents and god forbig, parents telling the thrugh about the con of Christ mess.
              </p>
              <p className="measure">
                 Get deep and dark, or find the humour, something out of the box...
              </p>
              <p className="measure">

                <Link className="fw7 link dim turquoise" to="/registration/" title="Registration">Register online</Link> now or <a className="fw7 link dim turquoise" href={EntryTwistedPdf}>download</a> the entry form.
              </p>
              
            </div>
          </div>
        </span>
      </article>
      <article className="bb b--black-10">
        <span className="db pv4 ph3 ph0-l no-underline black">
          <div className="flex flex-column flex-row-ns">
            <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
              <img src={AparimaPosterImg} className="db" alt="The Shape of Our Lives Exhibition" />
            </div>
            <div className="w-100 w-60-ns pl3-ns">
              <h2 className="mt0">The Shape of Our Lives Exhibition</h2>
              <p className="measure">
                <strong className="turquoise">15th November - December </strong><br />
                Open Wednesday till Sunday 11 - 4
              </p>  
            </div>
          </div>
        </span>
      </article>
      <article className="bb b--black-10">
        <span className="db pv4 ph3 ph0-l no-underline black">
          <div className="flex flex-column flex-row-ns">
            <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
              <img src={SteampunkImg} className="db" alt="Steampunk Exhibition" />
            </div>
            <div className="w-100 w-60-ns pl3-ns">
              <h2 className="mt0">Steampunk Exhibition</h2>
              <p className="measure">
                 Registration is now open for the October 2019 Exhibit. Download the <a href={SteampunkPdf}>registration form</a> or contact <a href="mailto:info@rivertonarts.org.nz" className="turquoise">info@rivertonarts.org.nz</a> for more information.
              </p>
              <h3>Quick Check Calendar</h3>
              <p className="measure">
                 <strong className="turquiose">Friday 6th September</strong><br />
                 Entry form and fee due.
              </p>
              <p className="measure">
                 <strong className="turquiose">Saturday 28th September</strong><br />
                 All artwork must be delivered by or dropped off no later than 4pm at the Riverton Community Arts Centre. 149 Palmerston Street, Riverton 9822.
              </p>
              <p className="measure">
                 <strong className="turquiose">Friday 11th October</strong><br />
                 Opening Night - Doors open 7pm. We invite you to come dressed in Steampunk attire (optional).
              </p>
              <p className="measure">
                 <strong className="turquiose">Saturday 12th October</strong><br />
                 Exhibition opens to the public. Gallery open Wednesday to Sunday 11am to 4pm.
              </p>
              <p className="measure">
                 <strong className="turquiose">Sunday 10th November</strong><br />
                 Exhibition closes. Collection of artworks unsold to be picked up between 4pm-6pm.
              </p>
            </div>
          </div>
        </span>
      </article>
      <article className="bb b--black-10">
        <span className="db pv4 ph3 ph0-l no-underline black" >
          <div className="flex flex-column flex-row-ns">
            <div className="pr3-ns mb4 mb0-ns w-100 w-40-ns">
              <img src={CalendarImg} className="db" alt="Closed for the Winter Season" />
            </div>
            <div className="w-100 w-60-ns pl3-ns">
              <h2 className="mt0">Calendar Year 2019-2020</h2>
              <p className="measure">
                Our 2019-2020 calendar is almost full. if you are interested in the spaces available or would like to have an exhibition in the future, please contact Rebecca Cooper - Arts Coordinator. Email <strong className="turquoise">info@rivertonarts.org.nz</strong> or phone <strong className="turquoise">028 409 5941.</strong>
              </p>
              <p className="measure">
                <Link className="fw7 link dim turquoise db" to={CalendarPdf} title="Download Calendar">Download the calendar.</Link>
              </p>
            </div>
          </div>
        </span>
      </article>
    </section>
  </Layout>
)

export default EventsPage

// export const query = graphql`
// query {
//   allWordpressPost (filter: {
//     categories: {
//       name: {
//         eq: "Events"
//       }
//     }
//     status:{
//       eq:"publish"
//     }
//   }) {
//     edges {
//       node {
//         id
//         title
//         content
//         slug
//         date
//         status
//         categories {
//           name
//         }
//         featured_media {
//           localFile
//           id
//           source_url
//           title
//           alt_text
//         }
//       }
//     }
//   }
// }
// `